export default "__VITE_ASSET__BNBMXQIj__"